<template>
  <div class="fixed inset-0 bg-black bg-opacity-50 z-30">
    <nav class="h-full bg-white px-5 pt-10 text-lg">
      <div class="flex justify-between">
        <ul>
          <li>
            <a
              :href="`${baseURL}`"
              class="block px-8 py-3"
              :class="isProfilePage ? 'home-screen' : ''"
            >
              Expert Sourcing
            </a>
          </li>
          <li>
            <a
              :href="`${baseURL}/contract-manufacturing`"
              class="block px-8 py-3"
            >
              Contract Manufacturing
            </a>
          </li>
          <li>
            <a
              :href="`${baseURL}/buy`"
              class="block px-8 py-3"
            >
              Buy
            </a>
          </li>
          <li>
            <a
              :href="`${baseURL}/finance-page`"
              class="block px-8 py-3"
            >
              Financing
            </a>
          </li>
          <li>
            <div
              @mouseleave="showAboutOptions = false"
              @click="showAboutOptions = !showAboutOptions"
              class="flex px-8 py-3"
            >
              <span>About Us</span>
              <img src="@/assets/icons/chevronDown.svg" class="ml-4 w-4">
            </div>
            <transition name="slide-down">
              <ul v-if="showAboutOptions" class="slide-down">
                <li>
                  <a
                    :href="`${baseURL}/about`"
                    class="inline-block px-10 py-1"
                  >
                    Our Story
                  </a>
                </li>
                <li>
                  <a
                    :href="buyhiveHowToBuyLink"
                    class="inline-block px-10 py-1"
                  >
                    How to Buy
                  </a>
                </li>
              </ul>
            </transition>
          </li>
        </ul>
        <div>
          <img
            src="@/assets/icons/close.svg"
            class="text-green right-0 mr-3"
            @click="close"
          >
        </div>
      </div>
      <div class="px-8 py-10">
        <hr>
      </div>
      <div>
        <ul v-if="isUserLoggedIn && getUserAuthInfo.role === 'freelancer'">
          <li class="px-8">
            <!-- <div class="bg-theme-light pl-4 pr-5 py-4 rounded-xl border border-gray-300 inline-block">
              <p>Your account<br>will be ready soon!</p>
              <p class="pt-3">
                Any questions?
                <a 
                  :href="`${baseURL}/buy/contact-us`"
                  class="text-blue underline"
                >Contact us</a>
              </p>
            </div> -->
          </li>
          <!-- <li @click="signOut">
            <router-link
              :to="{ name: 'Home' }"
              class="block px-8 py-3"
            >
              Logout
            </router-link>
          </li> -->
        </ul>
        <ul v-if="isUserLoggedIn && getUserAuthInfo.role === 'buyer'">
          <li>
            <a
              class="block px-8 py-3 rounded-full bg-opacity-10"
              :href="`${baseURL}/buy/profile`"
            >
              Account Settings
            </a>
          </li>
          <li>
            <a
              class="block px-8 py-3 rounded-full bg-opacity-10"
              :href="`${baseURL}/buy/profile/my-orders`"
            >
              My Orders
            </a>
          </li>
          <li>
            <a
              class="block px-8 py-3 rounded-full bg-opacity-10"
              :href="`${baseURL}/buy/profile/change-password`"
            >
              Change Password
            </a>
          </li>
          <li @click="signOut">
            <a class="block px-8 py-3 rounded-full bg-opacity-10">
              Logout
            </a>
          </li>
        </ul>
        <div v-if="!isUserLoggedIn" class="px-8">
          <a
            @click="close(), storeCurrentRoute(), openSignUpSelection()"
            class="inline-flex items-center justify-center border rounded-full border-blue px-6 text-blue py-2 w-40 mb-3 align-top md:mr-4"
          >
            <span class="ml-2">Register</span>
          </a>
          <a
            class="inline-flex items-center justify-center border rounded-full border-green px-6 text-green py-2 w-40"
            @click="close(), storeCurrentRoute(), openLoginSelection()"
          >
            <img src="@/assets/icons/user.svg">
            <span class="ml-2">Sign In</span>
          </a>
        </div>
      </div>
    </nav>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'MobileMenu',
  data() {
    return {
      showAboutOptions: false,
      buyhiveHowToBuyLink: process.env.VUE_APP_BUYHIVE_HOW_TO_BUY
    }
  },
  computed: {
    ...mapGetters ([
      'isUserLoggedIn',
      'getUserAuthInfo'
    ]),
    isProfilePage() {
      return this.$route.name === 'FreelancerList' ? true : false;
    },
    baseURL() {
      return process.env.VUE_APP_SERVER_BASE_URL
    },
    currentView() {
      return this.$route.name
    }
  },
  methods: {
    ...mapActions ([
      'logout',
      'openSignupSelectionModal',
      'openLoginSelectionModal'
    ]),
    openLoginSelection() {
      this.$router.push({name: 'LoginSelection'})
    },
    openSignUpSelection() {
      this.$router.push({name: 'SignupSelection'})
    },
    close() {
      this.$emit('close')
    },
    storeCurrentRoute() {
      localStorage.setItem('previousUrl', window.location.href)
    },
    async signOut() {
      this.close()
      const result = await this.logout()
      if (result) {
        window.location = process.env.VUE_APP_SERVER_BASE_URL
      }
    }
  }
}
</script>
<style scoped>
.home-screen {
  color: #00B2C9;
  font-weight: 600;
}
</style>